<template>
  <div class="overlay-layer my-6">
    <div>
      <img 
        src="/logo-green.png"
        alt="Keenthemes logo"
        width="64"
        class="logo mb-5">
      <div class="sk-flow">
        <div class="sk-flow-dot bg-primary"></div>
        <div class="sk-flow-dot bg-primary"></div>
        <div class="sk-flow-dot bg-primary"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.overlay-layer {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}
.sk-flow {
  width: calc(40px * 1.3);
  height: 15px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}

.sk-flow-dot {
  width: 15px;
  height: 15px;
  background-color: #ff6969;
  border-radius: 50%;
  animation: sk-flow 1.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s infinite both;
}

.sk-flow-dot:nth-child(1) { animation-delay: -0.30s; }
.sk-flow-dot:nth-child(2) { animation-delay: -0.15s; }

@keyframes sk-flow {
  0%, 80%, 100% {
    transform: scale(0.3); }
  40% {
    transform: scale(1); 
  }
}
</style>